import parse from "html-react-parser";
import { HiMiniLink } from "react-icons/hi2";

import { useEffect, useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { IoCodeSlashOutline } from "react-icons/io5";
import CustomImage from "../Image";

export default function Accordion({ data, siteTheme, isDay, isSingleText }) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setHeight(isOpen ? `${contentRef.current.scrollHeight}px` : "0px");
  }, [isOpen]);

  return (
    <div className="overflow-hidden">
      <div onClick={toggleAccordion}>
        <div
          className={`flex flex-row items-start justify-between w-full cursor-pointer ${
            isSingleText ? "my-2" : ""
          }`}
        >
          {!isSingleText ? (
            <div>
              <div className="flex flex-row items-center gap-2">
                {data?.logo ? (
                  <CustomImage
                    src={data?.logo}
                    alt={data?.name}
                    classname="w-[1rem] h-[1rem] object-cover rounded-full"
                  />
                ) : (
                  <div
                    className={`${siteTheme.toolBackground} rounded-full h-[1rem] w-[1rem]`}
                  />
                )}
                <p className="font-[400] text-md">{data?.company}</p>
                {data?.to === "present" && (
                  <div class="relative flex items-center justify-center">
                    <span class="absolute inline-flex h-2 w-2 rounded-full bg-orange-600 opacity-75 animate-ping"></span>
                    <span class="relative inline-flex rounded-full h-1 w-1 bg-orange-600"></span>
                  </div>
                )}
              </div>
              <div className="flex flex-row items-start gap-5 mt-2">
                <div
                  className={`${siteTheme.borderColor} border-[0.5px] p-[4px] rounded-md flex flex-row items-center gap-2 text-sm`}
                >
                  <IoCodeSlashOutline size={16} />
                </div>
                <div>
                  <p className="text-[14px] font-[400]">{data?.role}</p>
                  <p className="text-[12px] tracking-widest">
                    <span className="mr-1">{data?.status}</span> |{" "}
                    <span className="ml-1">
                      {data?.from} - {data?.to}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            // <div className={`border-l-[5px] pl-2 ${siteTheme.borderColor}`}>
            <div
              className={`w-[90%] sm:w-fit flex flex-row items-center justify-between gap-2`}
            >
              <p
                className={`${siteTheme.cardBackground} ${siteTheme.borderColor} rounded-sm border-[0.5px] px-2 py-1  text-xs tracking-wider`}
              >
                {data?.title}
              </p>
              <CustomImage
                src={data?.logo}
                alt={data?.name}
                classname="w-[2rem] object-cover rounded-full p-[4px] bg-white"
              />
            </div>
            // </div>
          )}
          <div
            className={`duration-500 ease-in-out transition-all ${
              isOpen ? "rotate-180" : ""
            } ${isDay ? siteTheme.textColor : "text-neutral-700"}`}
          >
            <IoIosArrowDown size={24} />
          </div>
        </div>
      </div>
      <div
        ref={contentRef}
        style={{ maxHeight: height }}
        className={`overflow-hidden transition-all duration-500 ease-in-out`}
      >
        <div
          ref={contentRef}
          className={`${
            isDay ? "text-black" : "text-white/50"
          } font-thin text-[14px] tracking-[0.08em] leading-loose font-saira`}
        >
          {parse(data?.job || data?.brief)}
        </div>
        {data?.path && (
          <div className="mt-1 mb-3 ml-5 w-fit border-l-[1px] pl-1 border-blue-700">
            <a
              href={data?.path}
              target="_black"
              rel="noopener noreferrer"
              className="text-[10px] text-blue-700 flex flex-row items-center gap-[3px] hover:text-blue-700/70 transition-all duration-500"
            >
              {data?.title}
              <HiMiniLink size={10} />
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
